(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('PublisherSearch', PublisherSearch);

    PublisherSearch.$inject = ['$resource'];

    function PublisherSearch($resource) {
        var resourceUrl =  'api/_search/publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
